var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"snackbar"},[_c('div',{staticClass:"snackbar__content"},[_vm._v(" "+_vm._s(_vm.text)+" ")]),_c('div',{staticClass:"snackbar__close",on:{"click":_vm.close}},[_vm._v(" × ")])])}
var staticRenderFns = []

export { render, staticRenderFns }